import {
  getDefaultEmailTemplate,
  renderPlaceholdersInTemplates
} from 'shared-helpers/email';
import { useDispatch, useReduxState } from 'hooks';
import { useApiData } from 'lib/api';
import api from 'api';
import { actions } from 'store';
import { GroupAttributeUsers, GroupUserAttributes, GroupUsers } from '.';

import type { GetEmailTemplatesByTypeRes } from 'shared-types/responses';

const GroupUsersContainer = () => {
  const { dispatch } = useDispatch();

  const {
    language,
    messages,
    pageState: { group },
    user
  } = useReduxState();

  const { data: emailTemplatesData } = useApiData<GetEmailTemplatesByTypeRes>({
    url: `/admin/email-templates-data?type=group-invite&groupId=${group.id}`
  });

  let emailTemplates = emailTemplatesData?.emailTemplates || [];

  emailTemplates = renderPlaceholdersInTemplates({
    emailTemplates,
    overridePlaceholderValues: {
      contactEmail: user?.email,
      groupTitle: group.title
    }
  });

  const emailTemplatesDefault = getDefaultEmailTemplate({
    language,
    emailTemplates
  });

  const handleAddOrEditUserAttribute = async (
    newConditions: (typeof group.userAttributes)[0],
    conditionsIndex?: number
  ) => {
    await api.put(`/admin/groups/${group.id}`, {
      userAttributes:
        conditionsIndex !== undefined
          ? [
              ...group.userAttributes.slice(0, conditionsIndex),
              newConditions,
              ...group.userAttributes.slice(conditionsIndex + 1)
            ]
          : [...group.userAttributes, newConditions]
    });
    const groups = await api.get(
      `/admin/groups?id=${group.id}&includeAdministeredGroups=true`
    );
    dispatch(actions.updatePageState({ group: groups.data.groups[0] }));
  };

  const handleRemoveUserAttribute = async (attributeIndex: number) => {
    await api.put(`/admin/groups/${group.id}`, {
      userAttributes: group.userAttributes.filter(
        (attr, i) => i !== attributeIndex
      )
    });
    const groups = await api.get(
      `/admin/groups?id=${group.id}&includeAdministeredGroups=true`
    );
    dispatch(actions.updatePageState({ group: groups.data.groups[0] }));
    return true;
  };

  return (
    <>
      <div>
        <GroupUsers
          emailTemplates={emailTemplates}
          emailTemplatesDefault={emailTemplatesDefault}
        />
      </div>

      <div style={{ marginTop: 40 }}>
        <GroupUserAttributes
          onAddUserAttribute={handleAddOrEditUserAttribute}
          onEditUserAttribute={handleAddOrEditUserAttribute}
          onRemoveUserAttribute={handleRemoveUserAttribute}
          tooltip={messages.groupsUserAttributesInfo}
          userAttributes={group.userAttributes}
        />
      </div>

      <div style={{ marginTop: 40 }}>
        <GroupAttributeUsers
          emailTemplates={emailTemplates}
          emailTemplatesDefault={emailTemplatesDefault}
        />
      </div>
    </>
  );
};

export default GroupUsersContainer;
